<template>
<div :class=" showSettle ? 'page page_order page_order_detail page_limit' : 'page page_order page_order_detail'">
	<!-- 物流信息 -->
    <div class="wuliu" v-if="logsticsList&&logsticsList.length>0">
        <div class="wuliu_t" >物流信息</div>
        <div class="wuliu_item clearfix" v-for="logstics in logsticsList" :key="logstics.id">
            <div class="wuliu_item_l f-l">{{logstics.time}}</div>
            <div class="wuliu_item_r f-l">{{logstics.description}}</div>
        </div>
    </div>
    <!-- 地址区域 -->
    <div class="item">
        <div class="adress">
            <div class="info" v-if="info != null">
                <div class="user">{{ info.person + ' ' + info.phone }}</div>
                <div class="dizhi">
                    {{ info.address }}
                </div>
            </div>
        </div>
    </div>
	<!-- 订单商品信息 -->
	<div class="list" v-if="info != null">
        <div class="item">
            <div class="item_t" @click="toTradsman">
                <div class="item_t_t">
                    <img :src="info.tradesman&&info.tradesman.thumb? ($publicData.withHttpStart(info.tradesman.thumb) ? info.tradesman.thumb :imageUrl+info.tradesman.thumb) :$publicData.defaultTouxiang" alt="" class="thumb" />
                    <div class="title">{{ info.tradesman&&info.tradesman.nickname?info.tradesman.nickname:'' }}</div>
                </div>
                <div class="status" >{{ orderStatus }}</div>
            </div>
            <div class="item_nr" @click="toGoodsDetail(info.made)">
                <div class="item_nr_l">
					<van-image :src="info.made.thumb?imageUrl+info.made.thumb:$publicData.intangibleDefault" class="tu" fit="contain" />
                    <!-- <img :src="info.made.thumb?info.made.thumb:$publicData.intangibleDefault" alt="" class="tu" /> -->
                </div>
                <div class="item_nr_r dingzhi" >
					<div class="info">
						<div class="title slh">{{ info.made.title }}</div>
						<div class="desc slh">{{ info.made.descript }}</div>
					</div>
					<div class="jiage"><span class="nums f-r">{{ info.num ? 'x'+ info.num : 'x' + 1  }}</span></div>
                </div>
            </div>
            <div class="item_extra">
                <div class="item_extra_l">邮费</div>
                <!-- <div class="item_extra_r">{{ orderDetail.fare }}</div> -->
				<div class="item_extra_r">￥{{ info.fare }}</div>
            </div>
			<!-- <div class="item_extra" v-if="discount && discount != 0">
                <div class="item_extra_l">折扣</div>
                <div class="item_extra_r">{{ dazhe }}</div>
            </div> -->
			<!-- <div class="item_extra shifu" v-if="dikouObj.user_money || dikouObj.chargecard  || dikouObj.parkscore_money && dikouObj.parkscore_money != 0">
				<span class="shifu_item" v-if="dikouObj.user_money">{{'余额抵扣: ' + dikouObj.user_money }}</span>
				<span class="shifu_item" v-if="dikouObj.chargecard">{{',' + '充值卡抵扣: ' + dikouObj.chargecard }}</span>
				<span class="shifu_item" v-if="dikouObj.parkscore_money">{{ '积分抵扣: ' + dikouObj.parkscore_money }}</span>
            </div> -->
			<div class="item_extra">
                <div class="item_extra_l">应付款</div>
                <div class="item_extra_r">
                    <div class="price"><span class="cash_tag">¥</span>{{ info.total_prices }}</div>
                </div>
            </div>
            <div class="item_extra">
                <div class="item_extra_l">预付款</div>
                <div class="item_extra_r">
                    <div class="price">
						<span class="cash_tag">¥</span>{{ info.deposit }}
						<span class="payStatus">{{ info.pay_status_deposit == 0 ? '未支付' : info.pay_status_deposit == 1 ? '支付中' :'已支付'}}</span>
					</div>
                </div>
            </div>
			<div class="item_extra">
                <div class="item_extra_l">尾款</div>
                <div class="item_extra_r">
                    <div class="price">
						<span class="cash_tag">¥</span>{{ info.final_payment }}
						<span class="payStatus">{{ info.pay_status_final == 0 ? '未支付' : info.pay_status_final == 1 ? '支付中' :'已支付'}}</span>
					</div>
                </div>
            </div>
			<div class="item_extra mark">
				<div class="mark_title">备注</div>
				<div class="mark_text">{{info.mark}}</div>
			</div>
			<div class="item_extra" v-if="info.madeorderphoto">
                <div class="item_extra_l">订单快照</div>
                <div class="item_extra_r kuaizhao" @click="toKuaizhao">
					<span class="">发生交易争议时，可作为判断依据</span>
					<van-icon name="arrow" />
				</div>
            </div>
        </div>
        <!-- 订单信息 -->
        <div class="item item_order" >
            <div class="title" >订单信息</div>
            <div class="order">
                <div class="">订单编号:{{ info.order_num }}</div>
                <div class="" v-for="pay in info.payorder" :key="pay.id">{{pay.type==1?'定金支付订单号':'尾款订单编号'}}: {{ pay.pay_order_num }}({{pay.pay_status==0?'未支付':'已支付'}})</div>
                <!-- <div class="">父订单编号:{{ pay.pay_order_num }}</div> -->
                <div class="">创建时间:{{ info.created_at }}</div>
                <!-- <div class="" v-if="orderDetail.pay_at">付款时间:{{ orderDetail.pay_at }}</div> -->
                <div class="return" v-if="info.order_status==3" >您好，退款金额将在3-5个工作日退回到您的原支付账户内，请您耐心等待。</div>
            </div>
        </div>
        <!-- 操作 -->
        <div class="actions">
            <div class="action" @click="serveClick">联系匠人</div>
            <div class="action" v-if="(info.order_status==1&&info.pay_status==0) || (info.order_status!=0&&info.pay_status==1)" @click="showSettle = true">支付定金</div>
            <!-- <div class="action" v-if="orderDetail.order_status!=0&&this.orderDetail.ship_status!=1" @click="cancelOrder">取消订单</div> -->
            <div class="action" v-if="info.order_status==1&&info.pay_status==2&&info.made_status==2" @click="toPay">支付尾款</div>
			<div class="action" v-if="info.order_status==1&&info.pay_status==3&&info.made_status==2&&info.ship_status==1&&info.receipt_status==0" @click="confirmorder">收货</div>
            <div class="action" v-if="info.order_status==2&&info.pay_status==3&&info.made_status==2&&info.ship_status==1&&info.receipt_status==1&&info.comment_status==0" @click="commentorder" >我要评论</div>
            <div class="action" v-if="info.order_status==2&&info.pay_status==3&&info.made_status==2&&info.ship_status==1&&info.receipt_status==1&&info.comment_status==1" @click="commentorder" >查看评论</div>
        </div>
		<!-- 提货码 -->
		<!-- <van-overlay :show="show_overlay" @click="show_overlay = false" /> -->
		<!-- <div class="custom_info" v-if="show_overlay">
			<div class="info_top">
				<div class="info_title">提货凭证</div>
				<img :src="publicPath+'statics/images/close_item.png'" alt="" class="info_close" @click="show_overlay = false">
			</div>
			<div class="info_nr" v-if="orderDetail.zt">
				<div class="tu_wrap">
					<img :src="publicPath+'statics/images/ziti_bg.png'" alt="" class="tu">
				</div>
				<div class="num_wrap">
					<div class="num_title">提货码</div>
					<div class="nums">{{orderDetail.zt.tihuocode}}</div>
				</div>
				<div class="text">
					<div class="text_info">
						<div class="text_info_l">提货手机：</div>
						<div class="text_info_r">{{orderDetail.zt.phone}}</div>
					</div>
					<div class="text_info zitidian">
						<div class="text_info_l">自提点：</div>
						<div class="text_info_r">{{orderDetail.zt.name}}</div>
					</div>
					<div class="text_info address">
						<div class="text_info_l">提货地址：</div>
						<div class="text_info_r">{{ orderDetail.zt.address }}</div>
					</div>
				</div>
			</div>
		</div> -->
    </div>
	<!-- 支付定金弹框 -->
	<van-overlay :show="showSettle" class-name="overlay">
		<div class="dingjin">
			<div class="top"></div>
			<div class="nr">
				<div class="nr_t">
					<img :src="publicPath+'statics/images/dingzhi/guize.png'" alt="" class="tu">
				</div>
				<div class="nr_m">
					<div class="">1、“定金”是平台根据匠人定制最终售价的一定比例所收首款，将作为本定制单交易开始的押金，交易达成后自动抵扣为订单费用；</div>
					<div class="">2、待定制作品完成后，平台将匠人按照用户需求匠心打造的作品照片发送至用户，并请用户进行“验收”；</div>
					<div class="">3、验收完成后，用户在平台进行“支付尾款”操作，如无特殊情况，平台将督促匠人于48小时内寄送出定制作品至用户地址接收处；</div>
					<div class="">4、用户收到定制作品后，如无质量问题，在平台进行“确认收货”操作，最终完成订单。</div>
				</div>
				<div class="nr_b">
					<div class="btn" @click="showSettle = false">取消</div>
					<div class="btn submit" @click="toPay">确定</div>
				</div>
			</div>
		</div>
	</van-overlay>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    // name: "my-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            active: 'a',
            id: this.$route.query.id,
            info: null,
            logsticsList: [],
			orderStatus:'',
			showSettle: false // 支付定金弹框
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '我的定制'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                    this.getLogstics()
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.getData()
                this.getLogstics()
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
            this.getData()
            this.getLogstics()
        }
    },
    methods: {
        // 获取列表
        getData() {
            var token = this.$store.getters.token;
            var params = {
                token: this.token,
                id: this.id,
            }
			this.$api.dingzhi.orderDetail(params).then(res=>{
				if(res.code == 200){
                    this.info = res.result
                    if (this.info.made) {
                        var album = this.info.made.album
                        var images = album.split(",");
                        if (images.length > 0) {
                            this.info.made.thumb = images[0]
                        }
                    } else if (this.info.customizedcommunity) {
                            this.info.made = {
                                title: this.info.customizedcommunity.title,
                                descript:this.info.customizedcommunity.content,
                                price_range: this.info.customizedcommunity.price,
                                thumb: ''
                            }
                            var album = this.info.customizedcommunity.album
                            console.log(album)
                            var images = album.split(",");
                            if (images.length > 0) {
                                this.info.made.thumb = images[0]
                            } else {
                                this.info.made.thumb = ''
                            }
                        }
                    
					// 订单
                    if (this.info.order_status == 0) {
                        this.orderStatus = '已取消'
                    } else if (this.info.order_status == 2) {
                        if (this.info.comment_status ==1) {
                            this.orderStatus = '已完成'
                        } else {
                            this.orderStatus = '待评价'
                        }
                    } else if (this.info.order_status == 3) {
                        this.orderStatus = '退款中'
                    } else if (this.info.pay_status == 0) {
                        this.orderStatus = '未付定金'
                    } else if (this.info.pay_status == 1) {
                        this.orderStatus = '支付中'
                    } else if (this.info.made_status == 1) {
                        this.orderStatus = '定制中'
                    } else if (this.info.pay_status == 2) {
                        this.orderStatus = '待付尾款'
                    } else if (this.info.receipt_status == 0) {
                        this.orderStatus = '待收货'
                    } else {
                        this.orderStatus = '已收货'
					}
					// 订单支付状态 定金 尾款
					for(var j in this.info.payorder){
						var pay = this.info.payorder[j]
						if(pay.type == 1){
							// 定金
							this.info.pay_status_deposit = pay.pay_status
							console.log()
						}else if(pay.type == 2){
							// 尾款
							this.info.pay_status_final = pay.pay_status
						}
					}
				} 
			})
        },
        serveClick() {
            var that = this;
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler("sdjy://member/memberInfo", memberParams, (data) => {
                    if (data.code == 200) {
                        that.token = data.result.token;
                        // console.log(that.info.tradesman)
                        var params = {
                            token: that.token,
                            uuid: that.info.tradesman.uuid
                        };
                        that.$api.xiaoxi.userInfo(params).then(res => {
                            if (res.code == 200) {
                                var tradesmanInfo = res.result;
                                // console.log('创建了与匠人的通信')
                                // that.$parent.sendMsgToTradesman('与' + that.tradesmanInfo.username + '建立了通信', that.mine.userId, that.tradesmanInfo.im_username);

                                that.toAppServe(tradesmanInfo);
                            }
                        })
                        // that.toAppServe(that.info.tradesman)
                    }
                });
            } else {
                if (!this.$store.getters.token) {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                    })
                    return
                }
                this.$router.push({
                    path: '/tradesman/chat',
                    query: {
                        uuid: this.info.tradesman.uuid
                    }
                })
                // this.$router.push({
                //     path: '/system/develop'
                // })
            }
        },
        toAppServe(tradesmanInfo) {
            var params = {
                data: {
                    toId: tradesmanInfo.im_username,
                    conversationId: tradesmanInfo.im_username,
                    toAvator: tradesmanInfo.tradesmans.thumb,
                    toName: tradesmanInfo.tradesmans.nickname,
                    toUUID: tradesmanInfo.tradesmans.uuid,
                    trandsmanId: tradesmanInfo.tradesmans.id
                },
            }
            console.log('params:',params)
            this.$bridge.callhandler("sdjy://public/chat", params, (data) => {

            });
        },
        getLogstics() {
            var token = this.$store.getters.token;
            var params = {
                token: this.token,
                id: this.id,
            }
			this.$api.dingzhi.logsticsList(params).then(res=>{
				if(res.code == 200){
                    this.logsticsList = res.result
				} 
			})
        },
        confirmorder() {
            var token = this.$store.getters.token;
            var params = {
                token: this.token,
                order_id: this.id,
            }
			this.$api.dingzhi.confirmorder(params).then(res=>{
				if(res.code == 200){
                    this.$toast('确认收货成功')
                    this.getData()
				} 
			})
        },
        commentorder() {
            if ( userAgent && userAgent.indexOf('shidaijiyi') != -1 ) {
                var params = {
                    'data':{
                        'url':this.$publicData.clientUrl+'/dingzhi/comment?orderId='+this.info.order_num+'&madeId='+this.info.made.id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/dingzhi/comment',
                    query: {
                            orderId: this.info.order_num,
                            madeId: this.info.made.id
                        }
                })
            }
        },
		// 
		toTradsman() {
            if ( userAgent && userAgent.indexOf('shidaijiyi') != -1 ) {
                var params = {
                    'data':{
                        'url':this.$publicData.clientUrl+'/art/detail?tradesmanId='+this.info.tradesman.id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/art/detail',
                    query: {
                            tradesmanId: this.info.tradesman.id
                        }
                })
            }
		},
		// 定制详情
		toGoodsDetail(made){
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/dingzhi/detail?id=' + made.id + '&pay_status='+ this.info.pay_status_deposit
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/dingzhi/detail',
                    query: {
							id: made.id,
							pay_status: this.info.pay_status_deposit
                        }
                })
            }
        },
        toPay() {
            var pay_order_num = ''
			var price = ''
			var dingzhi_status = ''
			var is_park = this.info.is_park == 1 ? 2 : 0 // 1 园区 0 非园区,支付页面,园区标识是2
            var park_uuid = this.info.to_park?this.info.to_park:''
            for (let i = 0; i < this.info.payorder.length; i++) {
                const pay = this.info.payorder[i];
                if (this.info.pay_status == 0  || this.info.pay_status == 1) {
                    if (pay.type == 1) {
                        pay_order_num = pay.pay_order_num
						price = pay.total_prices
						dingzhi_status = pay.type
                    }
                } else {
                    if (pay.type == 2) {
                        pay_order_num = pay.pay_order_num
						price = pay.total_prices
						dingzhi_status = pay.type
                    }
                }
            }
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/shop/pay?orderId=' + pay_order_num + '&price=' + price + '&isPlatprice='+ is_park +'&type=made'+'&dingzhi_status='+dingzhi_status+'&park_uuid='+park_uuid+'&is_chargecard='+this.info.made.is_chargecard
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/shop/pay',
                    query: {
                        orderId: pay_order_num,
                        price: price,
                        isPlatprice: is_park,
						type:'made',
						dingzhi_status: dingzhi_status,
                        park_uuid: park_uuid,
                        is_chargecard: this.info.made.is_chargecard,
                    }
                })
            }
        },
		// 订单快照
		toKuaizhao(){
			this.$router.push({
				path: "/order/dingzhi/kuaizhao",
				query: {
					orderId: this.id
				}
			})
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
	.page .price .payStatus{
		font-size: .24rem;
	}
</style>
